import React from 'react';
import { useCMS } from '../context/CMSContext';
import { Calendar, User, ArrowRight } from 'lucide-react';

const News = () => {
  const { content, getPageData } = useCMS();
  const pageData = getPageData('/news');

  const c = (key, fallback) => {
    if (pageData && pageData.sectionData) {
      const sections = ['header', 'posts'];
      for (const type of sections) {
        if (key.includes(`_${type}_`)) {
          const field = key.split(`_${type}_`)[1];
          const val = pageData.sectionData[type]?.[field];
          if (val) return val;
        }
      }
    }
    return content[key] || fallback;
  };

  const parseNews = (sectionDataObj, defaultData) => {
    if (!sectionDataObj) return defaultData;
    const news = [];
    for (let i = 1; i <= 10; i++) {
      if (sectionDataObj[`p${i}_title`]) {
        news.push({
          date: sectionDataObj[`p${i}_date`],
          author: sectionDataObj[`p${i}_author`],
          title: sectionDataObj[`p${i}_title`],
          desc: sectionDataObj[`p${i}_desc`],
          img: sectionDataObj[`p${i}_img`]
        });
      }
    }
    return news.length > 0 ? news : defaultData;
  };

  const newsItems = parseNews(pageData?.sectionData?.posts, [
    {
      date: 'MARCH 15, 2024',
      author: 'ADMIN',
      title: 'YELEP Cohort 5 Now Open Applications',
      desc: 'The Youth Empowered Leadership and Entrepreneurship Program returns for its fifth cohort in partnership with Shine Leadership International....',
      img: 'https://picsum.photos/seed/news1/600/400'
    },
    {
      date: 'MARCH 10, 2024',
      author: 'ADMIN',
      title: 'Call for Volunteers and Program Directors',
      desc: 'Are you passionate about serving communities in Uganda? We are inviting experienced individuals to lead initiatives across our six focus areas.',
      img: 'https://picsum.photos/seed/news2/600/400'
    },
    {
      date: 'FEBRUARY 28, 2024',
      author: 'ADMIN',
      title: 'How Youth Champions Are Transforming Lives',
      desc: 'Through the YELEP program, young leaders mobilized resources to support Christine Nazziwa, a single mother of six and survivor of domestic violence.',
      img: 'https://picsum.photos/seed/news3/600/400'
    },
    {
      date: 'FEBRUARY 20, 2024',
      author: 'ADMIN',
      title: 'Maama Mikka Appeal Improving Conditions',
      desc: 'Children at Mikka Parent School need safe learning environments. We are mobilizing resources to repair classrooms and renovate dormitories.',
      img: 'https://picsum.photos/seed/news4/600/400'
    }
  ]);

  return (
    <div className="animate-in fade-in duration-1000 bg-[#f4f3f0]">
      
      {/* 1. News Hero */}
      <section className="relative pt-40 pb-24 px-4 bg-white overflow-hidden border-b border-brandBeige/50">
        <div className="absolute top-0 right-0 w-1/2 h-full bg-[#f4f3f0] skew-x-[-15deg] translate-x-32 hidden lg:block"></div>
        <div className="max-w-7xl mx-auto relative z-10">
          <div className="max-w-2xl">
            <h1 className="text-5xl md:text-6xl font-black text-brandBlack mb-6" dangerouslySetInnerHTML={{__html: c('news_header_title', 'News & Insights')}}>
            </h1>
            <p className="text-lg text-brandBlack/60 leading-relaxed font-medium">
              {c('news_header_subtitle', 'Stories, opportunities, and updates from our work across communities in Uganda.')}
            </p>
          </div>
        </div>
      </section>

      {/* 2. News Grid */}
      <section className="py-24 bg-[#f4f3f0]">
        <div className="max-w-7xl mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 lg:gap-16">
            {newsItems.map((item, i) => (
              <NewsCard key={i} {...item} />
            ))}
          </div>
        </div>
      </section>

    </div>
  );
};

const NewsCard = ({ date, author, title, desc, img }) => (
  <div className="group flex flex-col h-full bg-white rounded-[2.5rem] overflow-hidden shadow-sm hover:shadow-md transition-all border border-brandBeige/20">
    <div className="aspect-[16/9] overflow-hidden bg-[#f4f3f0]">
      <img src={img} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" alt={title} />
    </div>
    
    <div className="p-8 flex flex-col flex-1">
      <div className="flex items-center gap-6 text-[10px] font-bold text-brandBlack/50 tracking-widest uppercase mb-6">
        <div className="flex items-center gap-2">
          <Calendar size={12} className="text-brandBlack/40" />
          {date}
        </div>
        <div className="flex items-center gap-2">
          <User size={12} className="text-brandBlack/40" />
          {author}
        </div>
      </div>
      
      <h3 className="text-2xl font-black text-brandBlack mb-4 group-hover:text-[#1b9a55] transition-colors leading-tight">
        {title}
      </h3>
      
      <p className="text-sm text-brandBlack/60 leading-relaxed mb-8 flex-1">
        {desc}
      </p>
      
      <div className="mt-auto">
        <button className="flex items-center gap-2 text-[#1b9a55] font-bold uppercase tracking-widest text-xs">
          Read More
          <ArrowRight size={14} className="group-hover:translate-x-1 transition-transform" />
        </button>
      </div>
    </div>
  </div>
);

export default News;

